<template>
  <div id="smartTown">
    <div class="title">国务院办公厅关于印发“十四五”国民健康规划的通知</div>
    <div class="text">为全面推进健康中国建设，根据《中华人民共和国国民经济和社会发展第十四个五年规划和2035年远景目标纲要》、《“健康中国2030”规划纲要》，编制本规划。</div>
    <div class="btn" @click="toLink()">查看详情</div>
    <!-- <div class="sub-title">国卫医发〔2022〕6号</div>
    <p>
      各省、自治区、直辖市卫生健康委、中医药局、医保局，新疆生产建设兵团卫生健康委、医保局，军队各有关单位：
    </p>
    <div class="text">
      为进一步提高医疗资源利用率，减轻人民群众就医负担，保障医疗质量和安全，我们制定了《医疗机构检查检验结果互认管理办法》，现印发给你们，请认真贯彻执行。
    </div>
    <div class="right">国家卫生健康委</div>
    <div class="right">国家中医药局</div>
    <div class="right">国家医保局</div>
    <div class="right">中央军委后勤保障部卫生局</div>
    <div class="right">2022年2月14日</div>
    <div class="title1">医疗机构检查检验结果互认管理办法</div>
    <div class="title1">第一章 总则</div>
    <div class="text">第一条 为进一步提高医疗资源利用率，减轻人民群众就医负担，保障医疗质量和安全，根据《中华人民共和国基本医疗卫生与健康促进法》《中华人民共和国医师法》《医疗机构管理条例》《医疗保障基金使用监督管理条例》《医疗质量管理办法》《医疗机构临床实验室管理办法》等有关法律法规规定，制定本办法。</div>
    <div class="text">第二条 本办法所称检查结果，是指通过超声、X线、核磁共振成像、电生理、核医学等手段对人体进行检查，所得到的图像或数据信息；所称检验结果，是指对来自人体的材料进行生物学、微生物学、免疫学、化学、血液免疫学、血液学、生物物理学、细胞学等检验，所得到的数据信息。检查检验结果不包括医师出具的诊断结论。</div>
    <div class="text">第三条 本办法适用于各级各类医疗机构。</div>
    <div class="text">第四条 医疗机构应当按照“以保障质量安全为底线，以质量控制合格为前提，以降低患者负担为导向，以满足诊疗需求为根本，以接诊医师判断为标准”的原则，开展检查检验结果互认工作。</div>
    <div class="title1">第二章 组织管理</div>
    <div class="text">第五条 国家卫生健康委负责全国医疗机构检查检验结果互认管理工作。国家医保局在职责范围内推进全国医疗机构检查检验结果互认支持工作。各地卫生健康行政部门负责本行政区域内医疗机构检查检验结果互认管理工作。各地医疗保障主管部门在职责范围内推进本行政区域内医疗机构检查检验结果互认支持工作。国家中医药局和军队卫生主管部门分别在职责范围内负责中医和军队医疗机构检查检验结果互认管理工作。</div>
    <div class="text">第六条 各地卫生健康行政部门应当加强对辖区内医疗机构的组织管理，指导医疗机构及其医务人员规范开展检查检验结果互认工作，按照全民健康信息平台建设功能指引要求，加强区域平台建设，推动辖区医疗机构检查检验结果的互通共享。</div>
    <div class="text">第七条 各地卫生健康行政部门根据《医疗质量管理办法》组建或者指定的各级、各专业医疗质量控制组织（以下简称质控组织）应当在同级卫生健康行政部门的指导下，制订完善本级检查检验项目质量评价指标和质量管理要求。各级质控组织应当加强本地区本专业检查检验项目的质量管理，定期规范开展质量评价工作，推动本地区医疗机构提升检查检验质量。</div>
    <div class="text">第八条 医疗机构应当按照医院信息化建设标准与规范要求，加强以电子病历为核心的医院信息平台建设。建立健全本机构内的互认工作管理制度，加强人员培训，规范工作流程，为有关医务人员开展互认工作提供必要的设备设施及保障措施。</div>
    <div class="text">第九条 医联体牵头医院应当推进医联体内数据信息的互联互通，加强检查检验的质量控制，提升检查检验的同质化水平，实现检查检验结果的互认共享。</div>
    <div class="text">第十条 医务人员应当遵守行业规范，恪守医德，合理诊疗，努力提高专业水平和服务质量，对符合条件的检查检验结果能认尽认。</div>
    <div class="title1">第三章 互认规则</div>
    <div class="text">第十一条 拟开展互认工作的检查检验项目应当具备较好的稳定性，具有统一的技术标准，便于开展质量评价。</div>
    <div class="text">第十二条 满足国家级质量评价指标，并参加国家级质量评价合格的检查检验项目，互认范围为全国。满足地方质量评价指标，并参加地方质控组织质量评价合格的检查检验项目，互认范围为该质控组织所对应的地区。不同地区通过签署协议，共同开展检查检验互认工作的，应当由有关地区卫生健康行政部门共同组建或者指定质控组织开展相关工作。参加相关质量评价并合格的，互认范围为协议地区。</div>
    <div class="text">第十三条 医疗机构检查检验结果互认标志统一为HR。检查检验项目参加各级质控组织开展的质量评价并合格的，医疗机构应当标注其相应的互认范围+互认标识。如：“全国HR”“京津冀HR”“北京市西城区HR”等。未按要求参加质量评价或质量评价不合格的检查检验项目，不得标注。</div>
    <div class="text">第十四条 省级卫生健康行政部门应当指导辖区医疗机构统一检查检验结果报告单样式，对于检验结果应当注明所使用的检测方法及参考区间。鼓励医疗机构将在同一区域范围内互认的检查检验结果在一份报告单中出具，并在报告单上统一标注相应互认区域范围和互认标识。</div>
    <div class="text">第十五条 各地卫生健康行政部门应当指导同级质控组织定期梳理辖区医疗机构互认项目清单，并按有关规定加强公示公开，便于医疗机构和社会公众查询了解。</div>
    <div class="text">第十六条 医疗机构及其医务人员应当在不影响疾病诊疗的前提下，对标有全国或本机构所在地区互认标识的检查检验结果予以互认。鼓励医务人员结合临床实际，在不影响疾病诊疗的前提下，对其他检查检验结果予以互认。</div>
    <div class="text">第十七条 对于患者提供的已有检查检验结果符合互认条件、满足诊疗需要的，医疗机构及其医务人员不得重复进行检查检验。</div>
    <div class="text">第十八条 医务人员应当根据患者病情开具检查检验医嘱。对于符合互认条件的检查检验项目，不得以与其他项目打包等形式再次收取相关费用。</div>
    <div class="text">第十九条 出现以下情况，医疗机构及其医务人员可以对相关项目进行重新检查：</div>
    <div class="text">（一）因病情变化，检查检验结果与患者临床表现、疾病诊断不符，难以满足临床诊疗需求的；</div>
    <div class="text">（二）检查检验结果在疾病发展演变过程中变化较快的；</div>
    <div class="text">（三）检查检验项目对于疾病诊疗意义重大的（如手术、输血等重大医疗措施前）；</div>
    <div class="text">（四）患者处于急诊、急救等紧急状态下的；</div>
    <div class="text">（五）涉及司法、伤残及病退等鉴定的；</div>
    <div class="text">（六）其他情形确需复查的。</div>
    <div class="text">第二十条 有条件的医疗机构可以开设检查检验门诊，由医学影像和放射治疗专业或医学检验、病理专业执业医师出诊，独立提供疾病诊断报告服务。</div>
    <div class="text">第二十一条 医疗机构及其医务人员应当加强医患沟通，对于检查检验项目未予互认的，应当做好解释说明，充分告知复检的目的及必要性等。</div>
    <div class="title1">第四章 质量控制</div>
    <div class="text">第二十二条 医疗机构开展检查检验所使用的仪器设备、试剂耗材等应当符合有关要求，并按规定对仪器设备进行检定、检测、校准、稳定性测量和保养。</div>
    <div class="text">第二十三条医疗机构应当加强检查检验科室的质量管理，建立健全质量管理体系，并将质量管理情况作为科室负责人综合目标考核的重要指标。</div>
    <div class="text">第二十四条医疗机构应当规范开展室内质量控制，并按照有关要求向卫生健康行政部门或者质控组织及时、准确报送本机构室内质量控制情况等相关质量安全信息。</div>
    <div class="text">第二十五条 医疗机构应当按照有关规定参加质控组织开展的质量评价。已标注互认标识的检查检验项目参加相应质量评价的频次不得少于半年一次。</div>
    <div class="text">第二十六条 各地卫生健康行政部门及其委托的质控组织应当按照有关规定，定期对辖区医疗机构的检查检验质量情况进行抽查。抽查工作应当以“双随机一公开”的方式组织开展。</div>
    <div class="title1">第五章 支持保障</div>
    <div class="text">第二十七条 各地卫生健康行政部门应当加强辖区检查检验能力建设，定期组织开展人员培训、现场检查、结果监控等工作。</div>
    <div class="text">第二十八条</div>
    <div class="text">（一）检查检验结果即可满足诊疗需要的，医疗机构按门（急）诊诊查收取相应的诊查费，不额外收费。</div>
    <div class="text">（二）检查检验结果符合互认要求，但确需相应检查检验科室共同参与方可完成检查检验结果互认工作的，可在收取诊查费的基础上参照本院执行的价格政策加收院内会诊费用。</div>
    <div class="text">（三）检查检验结果符合互认条件，但属于本办法第十九条所规定情形，无法起到辅助诊断作用，确需重新检查的，收取实际发生的医疗服务费用。</div>
    <div class="text">第二十九条 各级医疗保障部门应当积极推进支付方式改革，引导医疗机构主动控制成本，加强医疗服务行为的纵向分析与横向比较，强化医保基金使用绩效评价与考核机制。同时，合理确定医保基金预算总额，不因检查检验结果互认调减区域总额预算和单个医疗机构预算总额。</div>
    <div class="text">第三十条 有条件的医疗机构可以将医务人员开展检查检验结果互认工作的情况纳入本机构绩效分配考核机制。</div>
    <div class="text">第三十一条 鼓励各级医疗保障经办机构将医疗机构开展检查检验结果互认工作的情况作为医保定点机构评定标准。</div>
    <div class="title1">第六章 监督管理</div>
    <div class="text">第三十二条 各地卫生健康行政部门有权通过查阅、记录等方式对辖区内医疗机构开展互认工作的情况进行监督检查，医疗机构不得拒绝、阻碍或者隐瞒有关情况。</div>
    <div class="text">第三十三条 各地卫生健康行政部门应当定期开展工作考核，对于违反有关规定的医疗机构及其医务人员依法依规追究相关责任。</div>
    <div class="text">第三十四条 各地卫生健康行政部门应当充分运用信息化手段，对医疗机构检查检验结果互认和资料共享情况进行实时监测，对问题突出的医疗机构提出改进要求。</div>
    <div class="text">第三十五条 对于因检查检验结果互认而产生纠纷的，各责任主体依法依规承担相应责任。</div>
    <div class="text">第三十六条 伪造、变造、隐匿、涂改检查检验结果造成不良后果的，由违规主体依法依规承担相应责任。</div>
    <div class="title1">第七章 附则</div>
    <div class="text">第三十七条 本办法由国家卫生健康委会同国家医保局负责解释。</div>
    <div class="text">第三十八条 各省级卫生健康行政部门应当根据本办法，结合当地实际情况制定具体实施方案。鼓励有条件的地区，联合制定实施方案，推进检查检验结果跨省份互认。</div>
    <div class="text">第三十九条 本办法自2022年3月1日起施行。</div> -->
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('http://www.gov.cn/zhengce/content/2022-05/20/content_5691424.htm')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be ;
  border: 1px solid #1e73be;
}
.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
 text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news1.vue